import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { HalfBackgroundComponent } from 'src/app/shared/components';
import { BannerComponent } from 'src/app/shared/components/banner/banner.component';
import { LogoFacilityComponent } from 'src/app/shared/components/logo-facility/logo.component';
import { ScrollTopDirective } from 'src/app/shared/directives/scroll-top.directive';
import { NominationHandlerService } from 'src/app/shared/modules/nomination/services/nomination.service';
import { SearchInitModule } from 'src/app/shared/modules/search/search.module';
import { SearchAwbComponent } from './search-awb.component';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        ReactiveFormsModule,
        HalfBackgroundComponent,
        LogoFacilityComponent,
        MatCardModule,
        MatIconModule,
        SearchInitModule,
        ScrollTopDirective,
        BannerComponent,
    ],
    declarations: [SearchAwbComponent],
    providers: [NominationHandlerService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchModule {}
